window.ProductModel = {
	loadShopifyXR() {
		Shopify.loadFeatures([
			{
				name: "shopify-xr",
				version: "1.0",
				onLoad: this.setupShopifyXR.bind(this),
			},
		]);
	},

	setupShopifyXR(errors) {
		if (errors) return;

		if (!window.ShopifyXR) {
			document.addEventListener("shopify_xr_initialized", () =>
				this.setupShopifyXR()
			);
			return;
		}

		document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
			window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
			modelJSON.remove();
		});
		window.ShopifyXR.setupXRElements();
	},
};

window.addEventListener("DOMContentLoaded", () => {
	window.ProductModel?.loadShopifyXR();
});
